module.exports = __webpack_public_path__ + "assets/img/test.70d9076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.png
// module id = 54
// module chunks = 0